// Dashboard Rugby Vlaanderen
import React, { Component } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import moment from "moment-timezone";
import HeaderBar from "../../components/header/HeaderBar";
import { languages } from "../../constants/languages";

class RVDashboardContainer extends Component {
  state = {
    tournaments: [],
    tournamentsLoaded: false,
  };

  UNSAFE_componentWillMount = () => {
    window.firebase
      .firestore()
      .collection("tournamentsRV")
      .orderBy("date", "desc")
      .onSnapshot((querySnapshot) => {
        let tournaments = [];
        querySnapshot.forEach((doc) => {
          let tournament = doc.data();
          tournament["id"] = doc.id;
          tournaments.push(tournament);
        });
        this.setState({ tournaments: tournaments, tournamentsLoaded: true });
      });
  };

  render() {
    return (
      <div>
        <HeaderBar user={this.props.user} />
        <div
          style={{
            width: "100%",
            marginTop: 100,
            padding: 15,
            display: "flex",
          }}
        >
          <div style={{ flexGrow: 1 }}>
            {this.state.tournamentsLoaded && (
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>{languages.createTournament.date}</TableCell>
                    <TableCell>{languages.general.name}</TableCell>
                    <TableCell>{languages.login.email}</TableCell>
                    <TableCell>{languages.tournament.liveLink}</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {this.state.tournaments.map((tournament) => {
                    return (
                      <TableRow key={tournament.id}>
                        <TableCell>
                          {moment
                            .unix(tournament.date)
                            .format("dddd D MMMM YYYY")}
                        </TableCell>
                        <TableCell>{tournament.name}</TableCell>
                        <TableCell>{tournament.email}</TableCell>
                        <TableCell>
                          {tournament.liveLink ? (
                            <a
                              target="_blank"
                              rel="noopener noreferrer"
                              href={
                                "https://tournify.be/live/" +
                                tournament.liveLink
                              }
                            >
                              {tournament.liveLink}
                            </a>
                          ) : (
                            ""
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default RVDashboardContainer;
